// @flow
// Package level constants.
export const PACKAGE_REQUEST: string = 'PACKAGE_REQUEST';
export const PACKAGE_RECEIVE: string = 'PACKAGE_RECEIVE';
export const PACKAGE_INITIAL: string = 'PACKAGE_INITIAL';
export const PACKAGE_UPDATE: string = 'PACKAGE_UPDATE';

// Section level constants.
export const SECTION_NEXT: string = 'SECTION_NEXT';

// Page level constants.
export const PAGE_NEXT: string = 'PAGE_NEXT';

// Step level constants.
export const STEP_NEXT: string = 'STEP_NEXT';
export const STEP_PREV: string = 'STEP_PREV';

// Element.
export const ELEMENT_TOGGLE: string = 'ELEMENT_TOGGLE';



// WEBPACK FOOTER //
// ./src/constants/Package.js